import { LessonContent, LessonPdf } from '../../types/lessons';
import { CollectionData } from '../../types';
import { AxiosPrivate } from '../../utils';

interface Collection {
  data: CollectionData[];
}

interface IData {
  data: {
    id: number;
    pdf: LessonPdf;
    content: LessonContent;
  };
  meta: {
    collectionId: number;
    collectionName: string;
    exemplarId: number;
    exemplarName: string;
    stageId: number;
    stageName: string;
    textTypeId: number;
    textTypeName: string;
  };
}

class LessonsApi {
  private static instance: LessonsApi;

  public static getInstance(): LessonsApi {
    if (!LessonsApi.instance) {
      LessonsApi.instance = new LessonsApi();
    }
    return LessonsApi.instance;
  }

  getLesson = (id: number | string) => {
    return AxiosPrivate.get<IData>(`v1/lessons/${id}`);
  };

  getCollection = (id: number | string) => {
    return AxiosPrivate.get<Collection>(`v1/collections/${id}`);
  };

  getExemplars = (id: number) => {
    return AxiosPrivate.get(`v1/exemplars/${id}/related`);
  };
}

export const lessonsApi = LessonsApi.getInstance();
